import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';

import { NotificationContainerComponent } from './containers/notification-container/notification-container.component';
import { InformationCardRowContainerComponent } from '../infocard-row-container/information-card-row.container.component';
import { TextImageContainerComponent } from '../text-image-container/text-image.container.component';
import { FaqContainerComponent } from './containers/faq-container/faq-container.component';
import { ContentThreeTopTasksContainerComponent } from './containers/content-three-top-tasks-container/content-three-top-tasks-container.component';
import { ContentFourTopTasksContainerComponent } from './containers/content-four-top-tasks-container/content-four-top-tasks-container.component';
import { HeroContainerComponent } from '../hero-container/hero-container.component';
import { ContentSectionTextContainerComponent } from './containers/content-section-text-container/content-section-text-container.component';

@NgModule({
  imports: [
    provideLazyLoad({
      FaqSection: FaqContainerComponent,
      TextDefault: ContentSectionTextContainerComponent,
      TextWithCallToActionButton: ContentSectionTextContainerComponent,
      TextWithAppStoreButtons: ContentSectionTextContainerComponent,
      TextImageSection: TextImageContainerComponent,
      InformationCard2Section: InformationCardRowContainerComponent,
      InformationCard3Section: InformationCardRowContainerComponent,
      InformationCard4Section: InformationCardRowContainerComponent,
      ThreeTopTasksSection: ContentThreeTopTasksContainerComponent,
      FourTopTasksSection: ContentFourTopTasksContainerComponent,
      Hero: HeroContainerComponent,
      HeroMinimal: HeroContainerComponent,
      HeroWithAppButtons: HeroContainerComponent,
      HeroWithAsset: HeroContainerComponent,
      HeroWithWidget: HeroContainerComponent,
      NotificationSection: NotificationContainerComponent,
    }),
  ],
})
export class ContentLazyModule {}
